import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';
import pushNotificationService from '@/services/push-notifications';

const notificaciones = {
	state: {
		notificaciones : '',
		pushSubscription: null,
		pushEnabled: false,
		pushPermission: 'default'
	},
	getters: {
		getNotificaciones : state => state.notificaciones,
		getPushSubscription : state => state.pushSubscription,
		isPushEnabled : state => state.pushEnabled,
		getPushPermission : state => state.pushPermission
	}, 
	actions: {
		requestNotificaciones : function({commit,getters,dispatch}){

			let url = (getters.isEmpresa) ? '/api/Empresa/dameNotificaciones' : '/api/Alumno/dameNotificaciones';

			return new Promise((resolve, reject) => {
				axios.get(url).then(response => {
					if(response.data.status == 0){
						commit('setNotificaciones', response.data.datos)
					}else{
						commit('setCompleteError', response);
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});   

		},

		marcarNotificacionLeida : function({commit,getters,dispatch}, id){
			let url = (getters.isEmpresa) ? '/api/Empresa/marcarNotificacionLeida' : '/api/Alumno/marcarNotificacionLeida';
			return new Promise((resolve, reject) => {
				axios.post(url,{"id":id}).then(response => {
					if(response.data.status == 0){
						resolve(true);
					}else{
						commit('setCompleteError', response);
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});   

		},

		eliminaNotificacion : function({commit,getters,dispatch}, id){
			let url = (getters.isEmpresa) ? '/api/Empresa/eliminaNotificacion' : '/api/Alumno/eliminaNotificacion';
			return new Promise((resolve, reject) => {
				axios.post(url,{"id":id}).then(response => {
					if(response.data.status == 0){
						commit('setEraseNotificacion',id);
					}else{
						commit('setCompleteError', response);
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});   

		},

		marcarNotificacionesSinEnlaceLeidas : function({commit,getters,dispatch}){
			return new Promise((resolve, reject) => {
				let url = (getters.isEmpresa) ? '/api/Empresa/marcarNotificacionesSinEnlaceLeidas' : '/api/Alumno/marcarNotificacionesSinEnlaceLeidas';
				axios.post(url).then(response => {
					if(response.data.status == 0){
						resolve(true);
					}else{
						commit('setCompleteError', response);
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});   

		},

		borrarTodas : function({commit,getters,dispatch}){
			return new Promise((resolve, reject) => {
				let url = (getters.isEmpresa) ? '/api/Empresa/eliminaNotificaciones' : '/api/Alumno/eliminaNotificaciones';
				axios.post(url).then(response => {
					if(response.data.status == 0){
						commit('eraseAllNotificaciones')
					}else{
						commit('setCompleteError', response);
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});   

		},

		// Acciones para notificaciones push
		initializePushNotifications : async function({commit, getters}){
			try {
				const initialized = await pushNotificationService.initialize();
				if (initialized) {
					const permission = pushNotificationService.getPermissionStatus();
					commit('setPushPermission', permission);
					
					const subscription = await pushNotificationService.getSubscription();
					if (subscription) {
						commit('setPushSubscription', subscription);
						commit('setPushEnabled', true);
					}
				}
				return initialized;
			} catch (error) {
				console.error('Error al inicializar push notifications:', error);
				return false;
			}
		},

		subscribeToPushNotifications : async function({commit, getters, dispatch}, vapidPublicKey){
			try {
				// Suscribirse
				const subscription = await pushNotificationService.subscribe(vapidPublicKey);
				commit('setPushSubscription', subscription);
				commit('setPushEnabled', true);
				commit('setPushPermission', 'granted');

				// Enviar suscripción al servidor
				const url = getters.isEmpresa 
					? '/api/Empresa/registrarPushSubscription' 
					: '/api/Alumno/registrarPushSubscription';
				
				await pushNotificationService.sendSubscriptionToServer(url, subscription);
				
				return true;
			} catch (error) {
				console.error('Error al suscribirse a push notifications:', error);
				commit('setPushEnabled', false);
				throw error;
			}
		},

		unsubscribeFromPushNotifications : async function({commit, getters, dispatch}){
			try {
				// Eliminar del servidor
				const url = getters.isEmpresa 
					? '/api/Empresa/eliminarPushSubscription' 
					: '/api/Alumno/eliminarPushSubscription';
				
				await pushNotificationService.removeSubscriptionFromServer(url);

				// Desuscribirse localmente
				await pushNotificationService.unsubscribe();
				
				commit('setPushSubscription', null);
				commit('setPushEnabled', false);
				
				return true;
			} catch (error) {
				console.error('Error al desuscribirse de push notifications:', error);
				throw error;
			}
		},

		checkPushSubscription : async function({commit, getters}){
			try {
				const isSubscribed = await pushNotificationService.isSubscribed();
				const permission = pushNotificationService.getPermissionStatus();
				
				commit('setPushPermission', permission);
				commit('setPushEnabled', isSubscribed);
				
				if (isSubscribed) {
					const subscription = await pushNotificationService.getSubscription();
					commit('setPushSubscription', subscription);
				}
				
				return isSubscribed;
			} catch (error) {
				console.error('Error al verificar suscripción push:', error);
				return false;
			}
		},

	},
	mutations: {
		setNotificaciones : function(state,data){
			state.notificaciones = data;
		},
		setEraseNotificacion : function(state,id){
			state.notificaciones = state.notificaciones.filter(e => e.idNotificacion != id);	
		},
		eraseAllNotificaciones : function(state,id){
			state.notificaciones = []	
		},
		setPushSubscription : function(state, subscription){
			state.pushSubscription = subscription;
		},
		setPushEnabled : function(state, enabled){
			state.pushEnabled = enabled;
		},
		setPushPermission : function(state, permission){
			state.pushPermission = permission;
		}
	}
}

export default notificaciones;



// WEBPACK FOOTER //
// ./src/store/notificaciones.js